import { SearchType } from '@/types/most-search-type';

export const isProcedureSearch = (searchType: SearchType): boolean => {
  return [
    SearchType.IMAGE_EXAM,
    SearchType.LABORATORIAL_EXAM,
    SearchType.ONLINE_CONSULTATION,
    SearchType.PRESENTIAL_CONSULTATION,
    SearchType.VACCINE,
    SearchType.EMERGENCY,
    SearchType.SURGERY,
  ].includes(searchType);
};

export const isLaboratorialSearch = (searchType: SearchType): boolean => {
  return [
    SearchType.LABORATORIAL_EXAM,
    SearchType.IMAGE_EXAM,
    SearchType.VACCINE,
  ].includes(searchType);
};

export const isTelehealthSearch = (searchType: SearchType): boolean => {
  return searchType === SearchType.ONLINE_CONSULTATION;
};
